import React from 'react';
import Select from 'components/tags/Select/index.jsx';
import StartEndPicker from 'components/interaction/StartEndPicker/index.jsx';
import Checklist from 'components/interaction/Checklist/index.jsx';
import { idValues } from 'utils/arrays.js';
import { endOfDay, addDays, isBefore } from 'utils/date-fns/index.js';
import { EMPLOYMENT_EMPLOYED, EMPLOYMENT_ENTREPRENEUR } from '../constants.js';

import messages from './messages.js';
import CompanyInfo from './CompanyInfo/index.jsx';
import Document from './Document.jsx';
import UserAvatar from '../../user/UserAvatar/index.jsx';

const employmentOptions = [
  { value: EMPLOYMENT_EMPLOYED, label: messages.emplEmployed },
  { value: EMPLOYMENT_ENTREPRENEUR, label: messages.emplEntrepreneur },
];

function getRequestBeforeText(currentReason) {
  if (!currentReason?.requestBefore) {
    return undefined;
  }
  const num = currentReason.requestBefore;
  const values = (num % 7 === 0) ? { num: num / 7, unit: 'w' } : { num, unit: 'd' };
  return { ...messages.requestBefore, values };
}

function getSchema(values, options) {
  const { reportType, period, employmentType } = values;
  const { connections, types } = options;
  const currentReason = types[reportType];
  const needExplanation = currentReason && /^(Overig|Other)/.test(currentReason.description);
  const startAfter = currentReason && currentReason.requestBefore && endOfDay(addDays(new Date(), currentReason.requestBefore));
  const lateExplanation = period.start && isBefore(period.start, startAfter);
  const needAction = currentReason && currentReason.requireAction;
  const requestBeforeText = getRequestBeforeText(currentReason);

  return {
    id: 'leave-request-editor',
    properties: [
      {
        id: 'studentIds',
        as: Checklist,
        label: messages.studentIds,
        attributes: { asList: false, className: 'mt-3', items: connections, renderItem: (item) => <UserAvatar user={item} /> },
        type: 'array',
        required: true,
      },
      {
        id: 'reportType',
        as: Select,
        label: messages.reportType,
        placeholder: messages.selectReason,
        help: requestBeforeText,
        attributes: { options: idValues(types).map((type) => ({ value: type.id, label: type.description })) },
        type: 'number',
        required: true,
      },
      {
        id: 'period',
        as: StartEndPicker,
        label: messages.period,
        attributes: { future: true, withTime: false, requireEnd: true },
        required: true,
      },
      {
        id: 'explanation',
        type: 'textarea',
        label: messages.explanation,
        placeholder: needExplanation ? messages.explanationOtherPlaceholder : messages.explanationPlaceholder,
        attributes: { rows: 2, maxRows: 5 },
        required: needExplanation,
      },
      lateExplanation && {
        id: 'lateExplanation',
        type: 'textarea',
        label: messages.lateExplanation,
        placeholder: messages.lateExplanationPlaceholder,
        attributes: { rows: 2, maxRows: 5 },
        required: true,
      },
      needAction && {
        id: 'employmentType',
        as: Select,
        label: messages.employmentType,
        attributes: { options: employmentOptions },
        type: 'number',
        required: true,
      },
      needAction && Number(employmentType) === EMPLOYMENT_ENTREPRENEUR && {
        id: 'companyInfo',
        as: CompanyInfo,
        label: messages.companyInfo,
        required: true,
      },
      needAction && Number(employmentType) === EMPLOYMENT_EMPLOYED && {
        id: 'document',
        as: Document,
        label: messages.document,
        required: true,
      },
    ].filter(Boolean),
  };
}

export default getSchema;
